import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { DateTime } from "luxon";

import { InfoCard } from "@utilifeed/components";

import type { HumidityStatus } from "./useSensorOverviewData";

type IndoorClimateKpiCardsProps = Readonly<{
  avgTemp: number;
  avgTimestamp: DateTime;
  humidityStatus: HumidityStatus;
}>;

const IndoorClimateKpiCards = ({
  avgTemp,
  avgTimestamp,
  humidityStatus,
}: IndoorClimateKpiCardsProps) => {
  const { t } = useTranslation(["propai_properties", "propai"]);

  return (
    <Grid container spacing={2} alignItems="stretch">
      <Grid item xs={humidityStatus.type !== "none" ? 6 : 12}>
        <InfoCard
          title={t("average_indoor_temperature", { ns: "propai" })}
          value={isNaN(avgTemp) ? "N/A" : avgTemp.toFixed(2)}
          unit={isNaN(avgTemp) ? "" : "°C"}
          subtitle={avgTimestamp.toFormat("yyyy-MM-dd HH:mm")}
          subtitleVariant="labelLarge"
          isCardRounded
          color="tertiary"
        />
      </Grid>
      {humidityStatus.type !== "none" && (
        <Grid item xs={6}>
          <InfoCard
            title={t("average_indoor_humidity", { ns: "propai" })}
            value={
              humidityStatus.type === "available"
                ? humidityStatus.value.toFixed(2)
                : t("data_missing")
            }
            unit={humidityStatus.type === "available" ? "%" : ""}
            subtitle={
              humidityStatus.type === "available"
                ? DateTime.fromISO(humidityStatus.timestamp).toFormat("yyyy-MM-dd HH:mm")
                : t("no_current_readings")
            }
            subtitleVariant="labelLarge"
            isCardRounded
            color="tertiary"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default IndoorClimateKpiCards;
